import { UiStateStore } from 'src/app/shared/store/ui-state-store.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthenticationService } from 'src/app/auth/services/authentication.service';
import { Navigation } from '../../../../shared/models/navigation';
import { UserNotificationResponseDto } from 'src/app/shared/models/responses/user-notification.response';
import { DataService } from 'src/app/dashboards/services/data.service';
import { AuthenticationResult } from 'src/app/shared/models/authentication-result';

@Component({
  selector: 'app-dashboard-candidate-menu',
  templateUrl: './dashboard-menu.component.html',
  styleUrls: ['./dashboard-menu.component.scss']
})
export class DashboardCandidateMenuComponent implements OnInit, OnDestroy {

  public navigations: Navigation[] = Navigation.getCandidateNavigations().filter(n => n.title != "Search Jobs");
  public subscriptions: Subscription[] = [];
  stylesArray: string[] = [];
  userNotifications: UserNotificationResponseDto[] = [];
  unreadCount: number;
  user: AuthenticationResult = null;
  constructor(private authenticationService: AuthenticationService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private uiState: UiStateStore,
    private dataService: DataService) {

    this.resetStyles();

    this.stylesArray[0] = "active";
    let routerEventsSubscription = this.router.events.subscribe(val => {
      if (!this.activatedRoute.snapshot.firstChild) {
        return;
      }

      let childRoute = this.activatedRoute.firstChild.snapshot.url[0].path;
      let navigationIndex = this.navigations.findIndex(n => n.route.indexOf(childRoute) > -1);
      this.onMenuClicked(navigationIndex);
    });

    this.subscriptions.push(routerEventsSubscription);

    this.uiState.authenticatedUser.subscribe((user) => {
      if (!user) {
        return;
      }

      this.user = user;
      this.getUserNotifications();
    });

    this.uiState.currentNotification$.subscribe(resp => {
      if(resp && resp.notificationId){
        const existingNotification = this.userNotifications.find(x => x.notificationId == resp.notificationId);
        if(existingNotification) {
          this.userNotifications.forEach((x) => {
            if (x.notificationId == resp.notificationId) {
              x.isRead = true;
            }
          });
        } else {
          this.userNotifications.unshift(resp);
        }
        this.unreadCount = this.userNotifications.filter((x) => !x.isRead).length;
      }
    });
  }

  getUserNotifications = () => {
    this.dataService
      .getUserNotifications(this.user.accountId)
      .subscribe((resp) => {
        this.userNotifications = resp;
        this.unreadCount = this.userNotifications.filter((x) => !x.isRead).length;
      });
  };

  isMessagesTab = (navigation: Navigation) => {
    return navigation.title === "Messages";
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  public onMenuClicked(itemIndex: number): void {
    this.resetStyles();
    this.stylesArray[itemIndex] = "active";
  }

  resetStyles(): void {
    for (let i = 0; i < 7; i++) {
      this.stylesArray[i] = "";
    }
  }
}
